export function NewsArticleDetailsFields({ form, update }) {
  return (
    <>
      <label>
        Title
        <input
          data-testid="news-title-input"
          onChange={(event) => update("title", event.target.value)}
          required
          value={form.title}
        />
      </label>
      <div className="form-grid">
        <label>
          URL slug
          <input
            data-testid="news-slug-input"
            onChange={(event) => {
              update("slug", event.target.value.toLowerCase().replaceAll(" ", "-"));
            }}
            required
            value={form.slug}
          />
        </label>
        <label>
          Publish date
          <input
            data-testid="news-date-input"
            onChange={(event) => update("date", event.target.value)}
            required
            type="date"
            value={form.date}
          />
        </label>
        <label>
          Category
          <input
            data-testid="news-category-input"
            onChange={(event) => update("category", event.target.value)}
            required
            value={form.category}
          />
        </label>
        <label>
          Status
          <select
            data-testid="news-status-select"
            onChange={(event) => update("status", event.target.value)}
            value={form.status}
          >
            <option value="draft">Draft</option>
            <option value="published">Published</option>
            <option value="archived">Archived</option>
          </select>
        </label>
      </div>
      <label>
        Author
        <input
          data-testid="news-author-input"
          onChange={(event) => update("author", event.target.value)}
          required
          value={form.author}
        />
      </label>
      <label>
        Cover image URL
        <input
          data-testid="news-image-url-input"
          onChange={(event) => update("image_url", event.target.value)}
          required
          type="url"
          value={form.image_url}
        />
      </label>
    </>
  );
}

export function NewsArticleBodyFields({ form, update }) {
  return (
    <>
      <label>
        Summary
        <textarea
          data-testid="news-summary-input"
          onChange={(event) => update("summary", event.target.value)}
          required
          value={form.summary}
        />
      </label>
      <label>
        Full update
        <textarea
          data-testid="news-content-input"
          onChange={(event) => update("content", event.target.value)}
          required
          value={form.content}
        />
      </label>
    </>
  );
}